<template>
  <div>
    <h1 class="display-4">J'ai oublié mon mot de passe</h1>
    <hr />

    <form>
      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" class="form-control" id="email" placeholder="Votre adresse email" v-model="email">
        <div class="alert alert-danger mt-3" v-show="error_form">
          {{ message }}
        </div>
      </div>
      <button type="submit" class="btn btn-primary" @click.prevent="update">Valider</button>
      <router-link to="/">
        <a class="btn btn-large btn-link">Revenir à l'accueil</a>
      </router-link>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      email: '',
      error_form: '',
      message: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['domain'])
  },
  methods: {
    update () {
      this.error_form = false
      this.message = ''
      if (this.email !== '') {
        this.$http.post(this.domain + '/api/ionis/reset', { email: this.email }, { emulateJSON: true }).then((response) => {
          if (response.status === 204 && response.ok) {
            // this.flash('Vous avez reçu un email afin de pouvoir modifier votre mot de passe.', 'success', { timeout: 3000 })
            this.$root.$bvToast.toast('Vous avez reçu un email afin de pouvoir modifier votre mot de passe', {
              title: 'Email envoyé',
              autoHideDelay: 3000,
              append: false,
              variant: 'success'
            })
          }
        }, (response) => {
          if (response.status === 404) {
            // this.flash('Vous avez reçu un email afin de pouvoir modifier votre mot de passe.', 'success', { timeout: 3000 })
            this.$root.$bvToast.toast('Vous avez reçu un email afin de pouvoir modifier votre mot de passe', {
              title: 'Email envoyé',
              autoHideDelay: 3000,
              append: false,
              variant: 'success'
            })
          }
        })
      } else {
        this.error_form = true
        this.message = 'Vous devez renseigner ce champ'
      }
    }
  },
  mounted () {
    document.getElementById('email').focus()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reset.vue